import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import TableSettingsDrawerContent from "ds/components/Table/Settings/DrawerContent";

import useIacManagementAnalytics from "../../../useIacManagementAnalytics";
import useIacTableStore from "../useIacTableStore";

const TableSettingsDrawer = createDrawer(() => {
  const { trackAnalytics } = useIacManagementAnalytics();

  return <TableSettingsDrawerContent store={useIacTableStore} trackAnalytics={trackAnalytics} />;
});

export const showTableSettingsDrawer = createDrawerTrigger(TableSettingsDrawer);
